// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"495":"5e8d6dd0","979":"acbc6a9f"}[chunkId] + ".chunk.js";
};